/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="full"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const parentsProfileTableData =({
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"Invoice ID",align:"left"},
    {name:"Cycle", align:"left"},
    {name:"Amount", align:"left"},
    {name:"Invoice Image", align:"left"},
    {name:"Date & Time sent",align:"left"},
    {name:"Total Amount",align:"left"},
    {name:"Due Amount",align:"left"},
    {name:"Invoice Amount",align:"left"},
    {name:"Status",align:"left"},
    {name:"Action",align:"left"},
  ],

  rows: [
     {
      "sno":<ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
      "Invoice ID": <ArgonTypography variant="caption" color="text" fontWeight="medium">{"469830767"}</ArgonTypography>,
       "Invoice pic":<Author image={team2} />,
      "Type":  <ArgonTypography variant="caption" fontWeight="medium" color="text" >{"Online"}</ArgonTypography>,
      "Credit":<ArgonTypography variant="caption" color="text" fontWeight="medium">{"ABC University"}</ArgonTypography>,
      "Debit": <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Morning"}</ArgonTypography>,
      "Amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">{" 1 year"}</ArgonTypography>,
     
    },
    
    
   
    


    // {
    //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
    //   function: <Function job="Manager" org="Organization" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       23/04/18
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },


    // {
    //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
    //   function: <Function job="Programator" org="Developer" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       11/01/19
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },
    // {
    //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
    //   function: <Function job="Executive" org="Projects" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       19/09/17
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },
    // {
    //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
    //   function: <Function job="Programator" org="Developer" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       24/12/08
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },
    // {
    //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
    //   function: <Function job="Manager" org="Executive" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       04/10/21
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },
    // {
    //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
    //   function: <Function job="Programtor" org="Developer" />,
    //   status: (
    //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
    //   ),
    //   employed: (
    //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
    //       14/09/20
    //     </ArgonTypography>
    //   ),
    //   action: (
    //     <ArgonTypography
    //       component="a"
    //       href="#"
    //       variant="caption"
    //       color="secondary"
    //       fontWeight="medium"
    //     >
    //       Edit
    //     </ArgonTypography>
    //   ),
    // },
  ],
});

export default parentsProfileTableData;
